module.exports = __webpack_public_path__ + "static/media/bus-echtzeit.f7f5bed1.svg";